import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { SUITE_CARD } from '../../v2/constants/tracking/TrackingSources';
import MobileBundleFeatureTable from './MobileBundleFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileSuiteFeatureTable = ({
  productApiName,
  screen
}) => {
  const productLevel = getProductLevelFromApiNameString(productApiName);
  return /*#__PURE__*/_jsx(MobileBundleFeatureTable, {
    apiNames: [productApiName],
    productLevel: productLevel,
    screen: screen,
    trackingSource: SUITE_CARD
  });
};
export default MobileSuiteFeatureTable;